import { Grid, Button, TextField, Checkbox, FormControlLabel, ToggleButton, ToggleButtonGroup, Typography, Paper, Autocomplete, Box, Divider, Chip } from '@mui/material'
import { useEffect, useState } from 'react'
import { imageToBase64 } from '../../config'
import { useAuth, useUser } from '../../context'
import { CloudUpload, TextFields, PhotoLibrary, VideoLibrary } from '@mui/icons-material'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['clean']
    ],
    keyboard: {
        bindings: {
            bold: {
                key: 'B',
                shortKey: true,
                handler: function (range, context) {
                    this.quill.format('bold', !context.format.bold)
                }
            },
            italic: {
                key: 'I',
                shortKey: true,
                handler: function (range, context) {
                    this.quill.format('italic', !context.format.italic)
                }
            },
            underline: {
                key: 'U',
                shortKey: true,
                handler: function (range, context) {
                    this.quill.format('underline', !context.format.underline)
                }
            },
            bullet: {
                key: '8',
                shortKey: true,
                shiftKey: true,
                handler: function (range, context) {
                    this.quill.format('list', context.format.list === 'bullet' ? false : 'bullet')
                }
            },
            numbered: {
                key: '7',
                shortKey: true,
                shiftKey: true,
                handler: function (range, context) {
                    this.quill.format('list', context.format.list === 'ordered' ? false : 'ordered')
                }
            }
        }
    }
}

const formats = [
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent'
]

const WallPostEditorComponent = ({ roles, rolesSeleccionados, obras, setVideo, setImagen, onConfigChange, onSend, loading, initialData }) => {
    const { userData } = useAuth()
    const { isSuperAdmin } = useUser()

    const [typePost, setTypePost] = useState(initialData?.urlVideo ? 'title-video' : (initialData?.urlFile || initialData?.urlFoto ? 'text-photo' : 'only-text'))
    const [imageSelected, setImageSelected] = useState(initialData?.urlFile || initialData?.urlFoto)
    const [videoSelected, setVideoSelected] = useState(initialData?.urlVideo)
    const [rolesSelection, setRolesSelection] = useState([])
    const [obrasSelection, setObrasSelection] = useState([])
    const [notificarATodos, setNotificarATodos] = useState(initialData?.targetType === 'all')
    const [isVersionNote, setIsVersionNote] = useState(initialData?.isVersionNote || false)
    const [titulo, setTitulo] = useState(initialData?.title || initialData?.titulo || '')
    const [subtitulo, setSubtitulo] = useState(initialData?.subtitle || '')
    const [comentario, setComentario] = useState(initialData?.content || initialData?.comentario || '')

    useEffect(() => {
        if (initialData) {
            if (initialData.roles && roles.length > 0) {
                const selected = roles.filter(r => initialData.roles.includes(r.dbName))
                setRolesSelection(selected)
            }
            if (initialData.sites && obras.length > 0) {
                const selected = obras.filter(o => {
                    const id = typeof o === 'object' ? o._id : o
                    return initialData.sites.some(s => (s._id || s) === id)
                })
                setObrasSelection(selected)
            }
        }
    }, [initialData, roles, obras])
    useEffect(() => {
        const rolesSeleccionadosParaEnviar = rolesSelection.map(r => r.dbName)
        const obrasSeleccionadasParaEnviar = obrasSelection.map(o => o._id)

        let targetType = 'users'
        if (notificarATodos) targetType = 'all'
        else if (rolesSeleccionadosParaEnviar.length > 0 && obrasSeleccionadasParaEnviar.length > 0) targetType = 'filter'
        else if (rolesSeleccionadosParaEnviar.length > 0) targetType = 'roles'
        else if (obrasSeleccionadasParaEnviar.length > 0) targetType = 'sites'

        rolesSeleccionados(rolesSeleccionadosParaEnviar, titulo, comentario, obrasSeleccionadasParaEnviar)

        if (onConfigChange) {
            onConfigChange({
                targetType,
                isVersionNote,
                subtitle: subtitulo,
                createdBy: userData?._id
            })
        }
    }, [rolesSelection, titulo, subtitulo, comentario, obrasSelection, notificarATodos, isVersionNote, userData])

    const imagenSeleccionada = async (e) => {
        if (e.target.files[0]) {
            setImagen(e.target.files[0])
            const response = await imageToBase64(e.target.files[0])
            setImageSelected(response)
        }
    }

    const videoSeleccionado = async (e) => {
        if (e.target.files[0]) {
            setVideo(e.target.files[0])
            const reader = new FileReader()
            reader.readAsDataURL(e.target.files[0])
            reader.onload = function () {
                setVideoSelected(reader.result)
            }
        }
    }

    return (
        <Box sx={{ p: 2, maxWidth: 1200, margin: '0 auto' }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 4, bgcolor: '#fff' }}>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                <Box sx={{ display: 'flex', bgcolor: '#f0f0f0', p: 0.5, borderRadius: 3, border: '1px solid #ddd' }}>
                                    <Button
                                        onClick={() => setIsVersionNote(false)}
                                        sx={{
                                            borderRadius: 2.5,
                                            px: 3,
                                            py: 1,
                                            fontWeight: 700,
                                            bgcolor: !isVersionNote ? 'brown' : 'transparent',
                                            color: !isVersionNote ? '#fff' : '#666',
                                            '&:hover': { bgcolor: !isVersionNote ? '#5d0e0e' : '#e0e0e0' },
                                            transition: 'all 0.3s'
                                        }}
                                    >
                                        Publicación
                                    </Button>
                                    {isSuperAdmin && (
                                        <Button
                                            onClick={() => setIsVersionNote(true)}
                                            sx={{
                                                borderRadius: 2.5,
                                                px: 3,
                                                py: 1,
                                                fontWeight: 700,
                                                bgcolor: isVersionNote ? '#0288d1' : 'transparent',
                                                color: isVersionNote ? '#fff' : '#666',
                                                '&:hover': { bgcolor: isVersionNote ? '#01579b' : '#e0e0e0' },
                                                transition: 'all 0.3s'
                                            }}
                                        >
                                            Nota de Versión
                                        </Button>
                                    )}
                                </Box>

                                <FormControlLabel
                                    control={<Checkbox checked={notificarATodos} onChange={(e) => setNotificarATodos(e.target.checked)} color="secondary" />}
                                    label={<Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Notificar a Todos</Typography>}
                                />
                            </Box>

                            <ToggleButtonGroup
                                value={typePost}
                                exclusive
                                onChange={(e, val) => val && setTypePost(val)}
                                size="small"
                            >
                                <ToggleButton value="only-text" title="Solo Texto"><TextFields /></ToggleButton>
                                <ToggleButton value="text-photo" title="Imagen y Texto"><PhotoLibrary /></ToggleButton>
                                <ToggleButton value="title-video" title="Video y Texto"><VideoLibrary /></ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                        <Divider />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <Box>
                                <Typography variant="overline" sx={{ fontWeight: 700, color: '#888' }}>Segmentación</Typography>
                                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <Box sx={{
                                        border: '1px solid #eee',
                                        borderRadius: 2,
                                        p: 2,
                                        bgcolor: notificarATodos ? '#f9f9f9' : '#fff',
                                        opacity: notificarATodos ? 0.6 : 1
                                    }}>
                                        <Typography variant="subtitle2" sx={{ mb: 1, color: 'brown', fontWeight: 700 }}>Roles Destinatarios</Typography>
                                        <Box sx={{ maxHeight: 150, overflowY: 'auto' }}>
                                            {roles.map((rol, i) => (
                                                <FormControlLabel
                                                    key={rol._id || i}
                                                    disabled={notificarATodos}
                                                    control={
                                                        <Checkbox
                                                            size="small"
                                                            checked={rolesSelection.some(r => r.dbName === rol.dbName)}
                                                            onChange={(e) => {
                                                                if (e.target.checked) setRolesSelection([...rolesSelection, rol])
                                                                else setRolesSelection(rolesSelection.filter(r => r.dbName !== rol.dbName))
                                                            }}
                                                        />
                                                    }
                                                    label={<Typography variant="body2">{rol.name}</Typography>}
                                                />
                                            ))}
                                        </Box>
                                    </Box>

                                    <Autocomplete
                                        multiple
                                        disabled={notificarATodos}
                                        options={obras}
                                        getOptionLabel={(option) => option.descripcion}
                                        value={obrasSelection}
                                        onChange={(e, val) => setObrasSelection(val)}
                                        renderInput={(params) => <TextField {...params} label="Obras / Sitios" size="small" />}
                                        renderTags={(val, getTagProps) => val.map((opt, i) => (
                                            <Chip label={opt.descripcion} {...getTagProps({ i })} size="small" variant="outlined" color="primary" />
                                        ))}
                                    />
                                </Box>
                            </Box>

                            {typePost !== 'only-text' && (
                                <Box>
                                    <Typography variant="overline" sx={{ fontWeight: 700, color: '#888' }}>Archivo Adjunto</Typography>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        component="label"
                                        startIcon={<CloudUpload />}
                                        sx={{ mt: 1, borderColor: 'brown', color: 'brown' }}
                                    >
                                        Subir {typePost === 'text-photo' ? 'Imagen' : 'Video'}
                                        <input type="file" hidden accept={typePost === 'text-photo' ? 'image/*' : 'video/*'} onChange={typePost === 'text-photo' ? imagenSeleccionada : videoSeleccionado} />
                                    </Button>
                                    <Paper variant="outlined" sx={{ mt: 2, height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', bgcolor: '#f9f9f9', borderRadius: 2 }}>
                                        {typePost === 'text-photo' ? (
                                            imageSelected ? <img src={imageSelected} style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <Typography variant="caption">Vista previa</Typography>
                                        ) : (
                                            videoSelected ? <video controls src={videoSelected} style={{ width: '100%', height: '100%' }} /> : <Typography variant="caption">Vista previa</Typography>
                                        )}
                                    </Paper>
                                </Box>
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <Box>
                                <TextField
                                    fullWidth
                                    label="Título"
                                    placeholder="¿Cuál es la noticia principal?"
                                    variant="outlined"
                                    value={titulo}
                                    onChange={(e) => setTitulo(e.target.value)}
                                    inputProps={{ style: { fontSize: 20, fontWeight: 700 } }}
                                />
                                <TextField
                                    fullWidth
                                    label="Subtítulo"
                                    placeholder="Breve resumen"
                                    variant="outlined"
                                    sx={{ mt: 2 }}
                                    value={subtitulo}
                                    onChange={(e) => setSubtitulo(e.target.value)}
                                />
                            </Box>

                            <Box sx={{ minHeight: 300, display: 'flex', flexDirection: 'column' }}>
                                <Typography variant="caption" sx={{ mb: 1, fontWeight: 700, color: '#666' }}>Contenido</Typography>
                                <ReactQuill
                                    theme="snow"
                                    value={comentario}
                                    onChange={setComentario}
                                    modules={modules}
                                    formats={formats}
                                    placeholder="Escribe aquí el detalle..."
                                    style={{ height: 250, marginBottom: 50 }}
                                />
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button variant="text" color="inherit">Cancelar</Button>
                                <Button
                                    variant="contained"
                                    onClick={onSend}
                                    disabled={loading}
                                    sx={{ bgcolor: 'brown', px: 6, py: 1.5, borderRadius: 3, '&:hover': { bgcolor: '#5d0e0e' } }}
                                >
                                    {loading ? (initialData ? 'Actualizando...' : 'Publicando...') : (initialData ? 'Actualizar Ahora' : 'Publicar Ahora')}
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    )
}

export default WallPostEditorComponent
